import React from 'react';
import { StyledH2, StyledSubtitle } from '../../../Title/styles/Title.styled';
import { StyledReasonsSection } from './style/ReasonsSection.styled';
import { ReasonCard } from './components/ReasonCard';
import { SubscriptionButton } from '../../../ButtonLink/components/SubscriptionLink';
import { StyledLink } from '../../../links/style/Link.styled';

const firstCardStyles = `
    height: 550px;
    background-color: #8DC4CB;
    background-image: image-set(
        url('assets/mobile-index-ad-2x.webp') 1x type('image/webp'),
        url('assets/mobile-index-ad-2x.png') 1x type('image/png'),
        url('assets/mobile-index-ad-2x.webp') 2x type('image/webp'),
        url('assets/mobile-index-ad-2x.png') 2x type('image/png'),
        url('assets/mobile-index-ad-3x.webp') 3x type('image/webp'),
        url('assets/mobile-index-ad-3x.png') 3x type('image/png')
    );

    background-position: bottom center;

    & h3 {
        margin: 0;
    }

    @media screen and (min-width: 577px) {
        height: auto;
        background-image: image-set(
            url('assets/desktop-index-ad-2x.webp') 1x type('image/webp'),
            url('assets/desktop-index-ad-2x.png') 1x type('image/png'),
            url('assets/desktop-index-ad-2x.webp') 2x type('image/webp'),
            url('assets/desktop-index-ad-2x.png') 2x type('image/png'),
            url('assets/desktop-index-ad-3x.webp') 3x type('image/webp'),
            url('assets/desktop-index-ad-3x.png') 3x type('image/png')
        );
        background-size: 90%;
        background-position: bottom right -20px;
    }
`;
const secondCardStyles = `
    background-color: #96A0D6;
    background-image: image-set(
        url('assets/guitar-2x.webp') 1x type('image/webp'),
        url('assets/guitar-2x.png') 1x type('image/png'),
        url('assets/guitar-2x.webp') 2x type('image/webp'),
        url('assets/guitar-2x.png') 2x type('image/png'),
        url('assets/guitar-3x.webp') 3x type('image/webp'),
        url('assets/guitar-3x.png') 3x type('image/png')
    );
    background-position: top 30px center;
    background-size: 90px;

    @media screen and (min-width: 577px) {
        background-size: 132px;
    }
`;
const thirdCardStyles = `
    background-color: #D99CDD;
    background-image: image-set(
        url('assets/mobile-logo-2x.webp') 1x type('image/webp'),
        url('assets/mobile-logo-2x.png') 1x type('image/png'),
        url('assets/mobile-logo-2x.webp') 2x type('image/webp'),
        url('assets/mobile-logo-2x.png') 2x type('image/png'),
        url('assets/mobile-logo-3x.webp') 3x type('image/webp'),
        url('assets/mobile-logo-3x.png') 3x type('image/png')
    );
    background-position: top 55px center;
    background-size: 287px;

    @media screen and (min-width: 577px) {
        background-size: 315px;
        background-image: image-set(
            url('assets/desktop-logo-2x.webp') 1x type('image/webp'),
            url('assets/desktop-logo-2x.png') 1x type('image/png'),
            url('assets/desktop-logo-2x.webp') 2x type('image/webp'),
            url('assets/desktop-logo-2x.png') 2x type('image/png'),
            url('assets/desktop-logo-3x.webp') 3x type('image/webp'),
            url('assets/desktop-logo-3x.png') 3x type('image/png')
        );
    }
`;

export const ReasonsSection = () => {
    return (
        <StyledReasonsSection>
            <StyledH2 id="reasons-section">
                Зачем нужно оформлять подписку
            </StyledH2>
            <StyledSubtitle>
                Каждая песня имеет автора и исполнителя, которые получают
                отчисления с каждого воспроизведения или скачивания своего
                произведения. Эти отчисления выплачиваются с денег, которые наш
                проект зарабатывает либо на подписках, либо на рекламе
                <StyledLink
                    href="https://zaycev.net/spages/useragreement.shtml#useragreement-subscription"
                    target="_blank"
                >
                    Условия подписки
                </StyledLink>
            </StyledSubtitle>
            <div>
                <ReasonCard
                    title="Отсутствие рекламы"
                    subtitle="Если вам мешает реклама - можете оформить подписку, и она отключится."
                    specificCss={firstCardStyles}
                />
                <ReasonCard
                    title="Поддержка музыкантов"
                    subtitle="Если вы хотите поддержать музыкантов - можете оформить подписку."
                    specificCss={secondCardStyles}
                />
                <ReasonCard
                    title="Поддержка проекта"
                    subtitle="Если вы хотите поддержать разработчиков легендарного проекта рунета - можете оформить подписку."
                    specificCss={thirdCardStyles}
                />
            </div>
        </StyledReasonsSection>
    );
};
